<template>
  <div style="margin-top: 50px;font-size: 16px;text-align: center;letter-spacing: 2px">{{tipText}}</div>
</template>

<script>
import { mapActions } from 'vuex'
import { loginRequest } from '../assets/js/loginRequest'
export default {
  name: 'Jump',
  data () {
    return {
      tipText: ''
    }
  },
  created () {
    const account = this.$route.query.a.replace(/\s/g, '+')
    if (account) {
      this.tipText = '正在跳转中......'
      let data = JSON.parse(decodeURIComponent(escape(window.atob(account))))
      if (data.accountVal && data.passwordVal) {
        // 进行登录请求
        loginRequest(data.accountVal, data.passwordVal, true).then(res => {
          if (res.data.code === 200) {
            // stire储存token和用户信息
            this.SetTokenAndUser({
              token: res.headers.authorization,
              info: res.data.data
            })
            // 路由跳转
            this.$router.push({path: '/home'})
          } else {
            this.windowClose()
          }
          this.isLoading = false
        }).catch(() => {
          this.windowClose()
        })
      } else if (data.token && data.info) {
        // stire储存token和用户信息
        this.SetTokenAndUser({
          token: data.token,
          info: data.info
        })
        // 路由跳转
        this.$router.push({path: '/home'})
      } else {
        this.windowClose()
      }
    } else {
      this.windowClose()
    }
  },
  methods: {
    ...mapActions(['SetTokenAndUser']),
    windowClose () {
      // 关闭当前标签页
      var userAgent = navigator.userAgent
      if (userAgent.indexOf('Firefox') > -1 || userAgent.indexOf('Chrome') > -1) {
        // window.open('', '_self').close()
        window.location.href = 'about:blank'
      } else {
        window.opener = null
        window.open('about:blank', '_self')
        window.close()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Jump.vue